import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLanguage } from "../contexts/LanguageContext";

const GOLD_BORDER = "1.5px solid rgba(255, 213, 116, 0.78)";
const GOLD_SHADOW =
  "0 0 0 1px rgba(255, 239, 183, 0.18), 0 18px 40px rgba(5, 10, 25, 0.42)";
const BOOKWHEN_URL = "https://bookwhen.com/chesshood";

const COPY = {
  pageTitle: {
    en: "Lessons and Courses",
    pl: "Lekcje i kursy",
    es: "Clases y cursos",
  },
  onlineTitle: {
    en: "1-to-1 Online Lessons",
    pl: "Lekcje online 1 na 1",
    es: "Clases online 1 a 1",
  },
  howItWorks: {
    en: "How Lessons Work",
    pl: "Jak dzialaja lekcje",
    es: "Como funcionan las clases",
  },
  zoomNote: {
    en: "Zoom - Desktop or Tablet only",
    pl: "Zoom - tylko komputer lub tablet",
    es: "Zoom - solo ordenador o tablet",
  },
  imageCaption: {
    en: "Private online training with focused feedback, practical exercises and a clear plan for what to improve next.",
    pl: "Prywatny trening online z konkretnym feedbackiem, praktycznymi cwiczeniami i jasnym planem dalszej poprawy.",
    es: "Entrenamiento privado online con feedback concreto, ejercicios practicos y un plan claro para mejorar.",
  },
  lessonP1: {
    en: "Private one-to-one lessons on Zoom, usually around 60 minutes. Each lesson starts with a clear goal, a short warm-up and then the main theme chosen for you.",
    pl: "Prywatne lekcje jeden na jeden na Zoomie, zwykle okolo 60 minut. Kazda lekcja zaczyna sie od jasnego celu, krotkiej rozgrzewki i potem przechodzi do glownego tematu dobranego dla Ciebie.",
    es: "Clases privadas uno a uno por Zoom, normalmente de unos 60 minutos. Cada sesion empieza con un objetivo claro, un calentamiento breve y luego pasa al tema principal elegido para ti.",
  },
  lessonP2: {
    en: "We work on a shared board. You suggest moves, explain ideas, compare plans, review mistakes and turn patterns into simple rules you can use in real games.",
    pl: "Pracujemy na wspolnej szachownicy. Proponujesz ruchy, tlumaczysz pomysly, porownujesz plany, analizujesz bledy i zamieniasz motywy w proste zasady do gry praktycznej.",
    es: "Trabajamos sobre un tablero compartido. Propones jugadas, explicas ideas, comparas planes, revisas errores y conviertes patrones en reglas simples para partidas reales.",
  },
  lessonP3: {
    en: "Join from a PC or tablet. After each lesson you get a short recap of what to practise next, so progress continues between meetings.",
    pl: "Dolacz z komputera albo tabletu. Po kazdej lekcji dostajesz krotkie podsumowanie tego, co cwiczyc dalej, aby postep szedl miedzy spotkaniami.",
    es: "Unete desde ordenador o tablet. Despues de cada clase recibes un breve resumen de lo que conviene practicar a continuacion para seguir progresando entre sesiones.",
  },
  lessonPoints: {
    en: [
      "Openings, tactics, middlegame plans and simple endgames",
      "Practical decision-making without overload",
      "Useful feedback you can apply straight away",
    ],
    pl: [
      "Otwarcia, taktyka, plany gry srodkowej i proste koncowki",
      "Praktyczne decyzje bez przeciagzenia informacja",
      "Konkretne wskazowki do natychmiastowego zastosowania",
    ],
    es: [
      "Aperturas, tactica, planes de medio juego y finales simples",
      "Toma de decisiones practica sin sobrecarga",
      "Feedback util para aplicar de inmediato",
    ],
  },
  adultTitle: {
    en: "Adult Group Courses",
    pl: "Grupowe kursy dla doroslych",
    es: "Cursos grupales para adultos",
  },
  adultLead: {
    en: "For adults who always wanted to play chess but do not want to jump straight into strong club games. These sessions build the basics first and make the club path easier later.",
    pl: "Dla doroslych, ktorzy zawsze chcieli grac w szachy, ale nie chca od razu wskakiwac w silne gry klubowe. Te zajecia spokojnie buduja podstawy i ulatwiaja pozniejszy start w klubie.",
    es: "Para adultos que siempre quisieron jugar al ajedrez pero no quieren entrar directamente en partidas fuertes de club. Estas sesiones construyen la base primero y facilitan el camino al club despues.",
  },
  adultImageCaption: {
    en: "Adult group courses with a calmer route into chess, practical guidance and steady progress.",
    pl: "Grupowe kursy dla doroslych z lagodniejszym wejsciem w szachy, praktycznym prowadzeniem i spokojnym postepem.",
    es: "Cursos grupales para adultos con una entrada mas tranquila al ajedrez, orientacion practica y progreso constante.",
  },
  adultOfferTitle: {
    en: "Current offers",
    pl: "Aktualne oferty",
    es: "Ofertas actuales",
  },
  adultFee: {
    en: "One course fee. Attend Badger Farm Community Centre, Colden Common, or both.",
    pl: "Jedna oplata za kurs. Mozesz chodzic do Badger Farm Community Centre, Colden Common albo do obu miejsc.",
    es: "Una sola cuota del curso. Puedes asistir a Badger Farm Community Centre, Colden Common o a ambos.",
  },
  adultOffers: {
    en: [
      "Badger Farm Community Centre - Thursday, 7pm to 8pm",
      "Colden Common - Friday, 7pm to 8pm",
    ],
    pl: [
      "Badger Farm Community Centre - czwartek, 7pm do 8pm",
      "Colden Common - piatek, 7pm do 8pm",
    ],
    es: [
      "Badger Farm Community Centre - jueves, 7pm a 8pm",
      "Colden Common - viernes, 7pm a 8pm",
    ],
  },
  adultSkills: {
    en: "Openings, middlegame, endgames, calculation, notation, analysis, training habits and decision-making.",
    pl: "Otwarcia, gra srodkowa, koncowki, kalkulacja, zapis partii, analiza, nawyki treningowe i podejmowanie decyzji.",
    es: "Aperturas, juego medio, finales, calculo, anotacion, analisis, habitos de entrenamiento y toma de decisiones.",
  },
  adultBookTitle: {
    en: "Book when ready",
    pl: "Book when ready",
    es: "Book when ready",
  },
  adultBookCopy: {
    en: "Choose this when you want a calmer first step before full club play. It is designed for adults who want real structure, guided basics and practical confidence.",
    pl: "Wybierz to, jesli chcesz spokojniejszego pierwszego kroku przed pelna gra klubowa. To sciezka dla doroslych, ktorzy chca struktury, prowadzonych podstaw i praktycznej pewnosci siebie.",
    es: "Elige esto si quieres un primer paso mas tranquilo antes del juego completo de club. Esta pensado para adultos que quieren estructura real, bases guiadas y confianza practica.",
  },
  adultBookPoints: {
    en: [
      "You are not thrown straight into strong club games.",
      "You build foundations first and then move forward with more confidence.",
      "You get a practical route through openings, middlegame, endgames and analysis.",
    ],
    pl: [
      "Nie jestes od razu wrzucany w silne gry klubowe.",
      "Najpierw budujesz fundamenty, a potem idziesz dalej z wieksza pewnoscia.",
      "Dostajesz praktyczna sciezke przez otwarcia, gre srodkowa, koncowki i analize.",
    ],
    es: [
      "No entras directamente en partidas fuertes de club.",
      "Primero construyes fundamentos y luego avanzas con mas confianza.",
      "Recibes una ruta practica por aperturas, juego medio, finales y analisis.",
    ],
  },
  adultBook: {
    en: "Bookwhen list",
    pl: "Lista Bookwhen",
    es: "Lista Bookwhen",
  },
  adultBookListCopy: {
    en: "Choose one or several sessions from the current Bookwhen list.",
    pl: "Wybierz jeden lub kilka terminow z aktualnej listy Bookwhen.",
    es: "Elige una o varias sesiones de la lista actual de Bookwhen.",
  },
  adultBookList: {
    en: "Book now",
    pl: "Book now",
    es: "Book now",
  },
};

const OnlineMeetings = () => {
  const { pick } = useLanguage();

  const box = {
    background:
      "linear-gradient(180deg, rgba(12, 19, 38, 0.78), rgba(7, 12, 26, 0.88))",
    border: GOLD_BORDER,
    borderRadius: 28,
    color: "#f1efe8",
    padding: "clamp(18px, 3vw, 34px)",
    maxWidth: 1220,
    margin: "0 auto 24px auto",
    boxShadow: GOLD_SHADOW,
    backdropFilter: "blur(8px)",
  };

  const title = {
    color: "#fff0c8",
    fontSize: "clamp(1.9rem, 3vw, 2.6rem)",
    fontWeight: 900,
    textAlign: "center",
    margin: "6px 0 18px",
  };

  const sectionCard = {
    border: GOLD_BORDER,
    borderRadius: 24,
    padding: 18,
    background:
      "linear-gradient(180deg, rgba(14, 22, 44, 0.82), rgba(10, 16, 34, 0.92))",
    boxShadow: GOLD_SHADOW,
    height: "100%",
  };

  const subTitle = {
    color: "#fff0c8",
    fontSize: "1.08rem",
    fontWeight: 900,
    letterSpacing: "0.04em",
    margin: "0 0 12px",
    textTransform: "uppercase",
  };

  const desc = {
    fontSize: "1rem",
    lineHeight: 1.65,
    color: "#f1ecdf",
  };

  const note = {
    background: "rgba(255, 213, 116, 0.10)",
    border: GOLD_BORDER,
    borderRadius: 14,
    padding: "9px 14px",
    fontWeight: 800,
    color: "#ffebb8",
    margin: "0 0 16px 0",
    textAlign: "center",
  };

  const imageFrame = {
    borderRadius: 20,
    overflow: "hidden",
    border: GOLD_BORDER,
    boxShadow: "0 14px 32px rgba(0, 0, 0, 0.28)",
  };

  const imgStyle = {
    width: "100%",
    height: "auto",
    display: "block",
  };

  const imageCaption = {
    marginTop: 14,
    padding: "12px 14px",
    borderRadius: 18,
    border: "1px solid rgba(255, 213, 116, 0.35)",
    background: "rgba(255, 213, 116, 0.08)",
    color: "#f7efd8",
    lineHeight: 1.55,
  };

  const adultImageWrap = {
    width: "89%",
    margin: "0 auto 14px",
  };

  const stripeWrap = {
    display: "flex",
    justifyContent: "center",
    marginTop: 18,
  };

  const list = {
    margin: "12px 0 0",
    paddingLeft: 20,
    color: "#f1ecdf",
    lineHeight: 1.65,
  };

  const chip = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 44,
    padding: "0 16px",
    borderRadius: 14,
    border: GOLD_BORDER,
    background: "rgba(255, 213, 116, 0.10)",
    color: "#ffebb8",
    fontWeight: 900,
    marginTop: 14,
    textDecoration: "none",
  };

  const lessonTextWrap = {
    display: "grid",
    gap: 12,
  };

  const lessonPointsWrap = {
    margin: "4px 0 0",
    paddingLeft: 20,
    color: "#f1ecdf",
    lineHeight: 1.65,
  };

  const adultMiniTitle = {
    color: "#ffd76d",
    fontSize: "0.98rem",
    fontWeight: 900,
    letterSpacing: "0.04em",
    margin: "16px 0 8px",
    textTransform: "uppercase",
  };

  return (
    <div style={box}>
      <Container fluid className="p-0">
        <h2 style={title}>{pick(COPY.pageTitle)}</h2>

        <div style={{ display: "grid", gap: 20 }}>
          <div style={sectionCard}>
              <h3 style={subTitle}>{pick(COPY.onlineTitle)}</h3>
              <div style={note}>{pick(COPY.zoomNote)}</div>

              <div style={imageFrame}>
                <img
                  src="online.png"
                  alt="Private chess lesson over Zoom on a desktop"
                  style={imgStyle}
                />
              </div>
              <div style={imageCaption}>{pick(COPY.imageCaption)}</div>

              <div style={lessonTextWrap}>
                <div style={desc}>
                  <div style={adultMiniTitle}>{pick(COPY.howItWorks)}</div>
                  <p>{pick(COPY.lessonP1)}</p>
                  <p>{pick(COPY.lessonP2)}</p>
                  <p>{pick(COPY.lessonP3)}</p>
                </div>
                <ul style={lessonPointsWrap}>
                  {pick(COPY.lessonPoints).map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>

              <div style={stripeWrap}>
                <a href="/online-chess-lessons.html" style={chip}>
                  {pick({
                    en: "Choose an online lesson time · Morning rates available",
                    pl: "Wybierz termin lekcji online · Tańsze poranki",
                    es: "Elige tu clase online · Tarifa reducida por la mañana",
                  })}
                </a>
              </div>
          </div>

          <div style={sectionCard}>
              <div style={desc}>
                <h3 style={subTitle}>{pick(COPY.adultTitle)}</h3>
                <div style={imageFrame}>
                  <div style={adultImageWrap}>
                    <img
                      src="adult.png"
                      alt="Adult chess course"
                      style={imgStyle}
                    />
                  </div>
                </div>
                <div style={imageCaption}>{pick(COPY.adultImageCaption)}</div>
                <p>{pick(COPY.adultLead)}</p>
                <div style={note}>{pick(COPY.adultOfferTitle)}</div>
                <p>{pick(COPY.adultFee)}</p>
                <ul style={list}>
                  {pick(COPY.adultOffers).map((offer) => (
                    <li key={offer}>{offer}</li>
                  ))}
                </ul>
                <p style={{ marginTop: 14 }}>{pick(COPY.adultSkills)}</p>
                <div style={adultMiniTitle}>{pick(COPY.adultBookTitle)}</div>
                <p>{pick(COPY.adultBookCopy)}</p>
                <ul style={list}>
                  {pick(COPY.adultBookPoints).map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                <div style={adultMiniTitle}>{pick(COPY.adultBook)}</div>
                <p>{pick(COPY.adultBookListCopy)}</p>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
                  <a
                    href={BOOKWHEN_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={chip}
                  >
                    {pick(COPY.adultBookList)}
                  </a>
                </div>
              </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OnlineMeetings;

